<div class="flex flex-col justify-center items-center h-[50vh] lg:h-[70vh]">
  <ng-lottie
    width="24rem"
    [options]="options"
  >
  </ng-lottie>
  <span class="animate-pulse mt-4 font-bold text-primary-500 uppercase">{{ label }}</span>
</div>
